// Keep in sync with UNEXPECTED_ERROR_MSG in lib/exceptions.py
export const GENERIC_ERROR_MESSAGE =
  'Sorry, an unexpected error occurred. Please try again or reach out to support@benchling.com if the issue persists.';

export const GENERIC_NETWORK_ERROR_MESSAGE =
  'Experiencing errors connecting to Benchling. Please check your network connection and reach out to support@benchling.com if the issue persists.';

export const GENERIC_SHORT_ERROR_MESSAGE = 'Sorry, an unexpected error occurred';
